import { create } from 'zustand';
import type { InvoiceTravelInformation } from 'contracts/tracking-v2/invoice-travel-information';

type State = {
  travelInformation?: InvoiceTravelInformation,
}

type Actions = {
  setTravelInformation: (travelInformation: InvoiceTravelInformation) => void,
  resetInvoiceTravelInformationStoreState: () => void,
}

const getInitialState = (): State => ({
  travelInformation: undefined,
});

export const useInvoiceTravelInformationStore = create<State & Actions>(
  (set) => ({
    ...getInitialState(),
    setTravelInformation: (travelInformation) => set({ travelInformation }),
    resetInvoiceTravelInformationStoreState: () => set(getInitialState()),
  }),
);